import { useAppDispatch, useAppSelector } from "@hooks/useTypedRedux";
import Snackbar from "@mui/material/Snackbar";
import MuiAlert from "@mui/material/Alert";
import { closeNotification } from "@features/modals/notificationModalSlice";
import { forwardRef } from "react";

const Alert = forwardRef<HTMLDivElement, any>(function Alert(props, ref) {
  return <MuiAlert elevation={6} ref={ref} variant="filled" {...props} />;
});

export const GlobalSnackbar = () => {
  const dispatch = useAppDispatch();
  const { open, message, severity } = useAppSelector(
    (state) => state.notificationState
  );

  const handleClose = (_event?: any, reason?: string) => {
    if (reason === "clickaway") return;
    dispatch(closeNotification());
  };

  return (
    <Snackbar
      open={open}
      autoHideDuration={4000}
      onClose={handleClose}
      anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
    >
      <Alert
        onClose={handleClose}
        severity={severity}
        sx={{
          display: "flex",
          padding: "16px",
          fontFamily: "Roboto Condensed",
          borderRadius: "8px",
          backgroundColor: "#323232",
          fontSize: "14px",
          fontStyle: "normal",
          fontWeight: "400",
          lineHeight: "normal",
          color: "#fff",
          boxShadow:
            "0px 6px 10px 0px rgba(0, 0, 0, 0.14), 0px 1px 18px 0px rgba(0, 0, 0, 0.12), 0px 3px 5px 0px rgba(0, 0, 0, 0.20);",
          alignItems: "center",
          gap: "10px",
        }}
      >
        {message}
      </Alert>
    </Snackbar>
  );
};
